<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="dedication"></a><a id="page_v">FOR MOM,</a></p><a id="page_v">
</a><p class="dedication1"><a id="page_v"><span class="txit">my bestie</span></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?66cd8a6f